// Local mirror of the backend's src/resource-homework-guard/resource-homework-guard.types.ts
// and dto/homework-resolution.dto.ts (SCRUM-1020). Kept in sync by hand — the
// two repos deploy independently, so this is intentionally not a cross-repo
// import.
export const HOMEWORK_RESOLUTION_ACTION = {
  REPOINT: "repoint",
  WITHDRAW: "withdraw",
} as const;

export type HomeworkResolutionAction =
  (typeof HOMEWORK_RESOLUTION_ACTION)[keyof typeof HOMEWORK_RESOLUTION_ACTION];

export interface ResourceHomeworkImpact {
  resource_id: number;
  resource_title: string;
  replacement_resource_id: number | null;
  game_quiz_id_matches: boolean | null;
  // SCRUM-1590: null when there is no replacement to compare against. An
  // older backend does not send it.
  resource_type_matches?: boolean | null;
  homework_count: number;
  homework_ids: number[];
  classroom_count: number;
  school_count: number;
  student_count: number;
  completed_count: number;
  incomplete_count: number;
  future_scheduled_count: number;
  in_flight_attempt_count: number;
}

export interface HomeworkResolutionDto {
  resource_id: number;
  action: HomeworkResolutionAction;
  new_resource_id?: number;
  // SCRUM-1590: true = same exercise, false = different content.
  same_exercise_assertion?: boolean;
  acknowledge_in_flight?: boolean;
}

// SCRUM-1590: the backend refuses "same exercise" when the replacement is of
// another type or has another quiz.
export const NOT_SAME_EXERCISE_ERROR = "NOT_SAME_EXERCISE";
